import { ModalCreateBrandComponent } from './../modal-create-brand/modal-create-brand.component';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
// Xóa MatPaginator khỏi import
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { BrandService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
@Component({
  selector: 'meu-app-brand-management',
  templateUrl: './app-brand-management.component.html',
  styleUrls: ['./app-brand-management.component.scss'],
})
export class AppBrandManagementComponent implements OnInit {
  // Xóa ViewChild(MatPaginator)
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private brandService: BrandService
  ) {}
  displayedColumns: string[] = ['Index', 'Logo', 'Name', 'Code', 'Country', 'Actions'];
  lstAllBrand: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  host: any;
  filter: any = '';

  // Thêm dòng này
  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.pageSize = 10;
        // this.paginator.firstPage(); // Xóa dòng này
        this.filter = 'name|code|nation@=*' + value;
        this.getAllBrand();
      });
    this.getAllBrand();
  }
  public keyUp = new Subject<KeyboardEvent>();
  getAllBrand() {
    this.brandService
      .apiBrandsGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAllBrand = res.data.collection;
          // this.pageSize = res.data.pagesize; // Tắt dòng này
          // this.pageIndex = res.data.pageIndex; // Tắt dòng này
          this.total = res.data.total;
          this.host = environment.backendhost;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  // --- THAY THẾ LOGIC PHÂN TRANG ---
  // Xóa hàm paginatorChange(event) và thay bằng 2 hàm sau:

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllBrand();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1; // Quay về trang 1
    this.getAllBrand();
  }
  // --- KẾT THÚC THAY THẾ ---

  openModalBrand(id) {
    const dialogRef = this.dialog.open(ModalCreateBrandComponent, {
      width: '900px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới hãng thành công');
            this.getAllBrand();
          } else {
            this.toastr.success('Chỉnh sửa hãng thành công');
            this.getAllBrand();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }
  deleteBrand(ID) {
    const title = 'Xóa hãng';
    const description = 'Bạn có chắc chắn muốn xóa hãng này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.brandService.apiBrandsIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá hãng thành công');
            this.getAllBrand();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }
}
